import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, BUSINESS } from "@/data/content";
import { Button } from "@/components/ui/button";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#areas", label: "Service Area" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Contact" },
  { href: "#contact", label: "Get Quote" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-3"
          data-testid="header-logo"
        >
          <img
            src={LOGO_URL}
            alt="Spotless Water Works"
            className="h-12 w-auto object-contain"
          />
          <div className="hidden sm:block leading-tight">
            <div className="font-display text-white text-lg uppercase tracking-tight">
              Spotless
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#C4FF00] font-bold">
              Water Works
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm uppercase tracking-widest font-semibold text-zinc-300 hover:text-[#C4FF00] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            className="hidden md:flex items-center gap-2 text-sm font-bold text-white hover:text-[#00BFFF] transition-colors"
            data-testid="header-phone"
          >
            <Phone className="h-4 w-4" />
            {BUSINESS.phone}
          </a>
          <a href="#contact">
            <Button
              className="hidden md:inline-flex bg-[#C4FF00] text-black hover:bg-[#D4FF33] font-bold uppercase tracking-widest text-xs px-5 h-10 rounded-full"
              data-testid="header-cta-quote"
            >
              Get Quote
            </Button>
          </a>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="header-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-bold uppercase tracking-widest text-white hover:text-[#C4FF00]"
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={BUSINESS.phoneHref}
              className="flex items-center gap-2 text-base font-bold text-[#00BFFF]"
            >
              <Phone className="h-4 w-4" />
              {BUSINESS.phone}
            </a>
            <a href="#contact" onClick={() => setOpen(false)}>
              <Button className="w-full bg-[#C4FF00] text-black hover:bg-[#D4FF33] font-bold uppercase tracking-widest rounded-full h-11">
                Get Quote
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
